export default "__VITE_ASSET__Ch9FC1lG__"